import type { WebVttCue } from './WebVttCue';

/**
 * A factory for creating WebVttCue objects.
 *
 * @group WebVTT
 *
 * @beta
 */
export type WebVttCueFactory = () => WebVttCue;
